import React from "react"

import type { GraphPngCurrent } from "../graph-to-png/graph-to-png.types"

const MenuRefContext =
  React.createContext<React.RefObject<GraphPngCurrent | null> | null>(null)

export default MenuRefContext
